// extracted by mini-css-extract-plugin
export var submitBtn = "form-module--submitBtn--qigDG";
export var formBtn = "form-module--form-btn--ynWx-";